/**
 * Circular exclamation icon with configurable fill color and dimensions.
 *
 * @param props.fillColor - Fill color for the glyph (defaults to red `#FF0000`).
 * @param props.width - SVG width (defaults to `24`).
 * @param props.height - SVG height (defaults to `24`).
 * @param props.strokeColor - Optional stroke color.
 * @returns The rendered exclamation SVG icon.
 */
const ExclamationWithFillColor = (props: {
  fillColor?: string;
  width?: string;
  height?: string;
  strokeColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "24"}
    height={props.height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.658 12C23.658 18.6274 18.439 24 12.0009 24C5.56283 24 0.34375 18.6274 0.34375 12C0.34375 5.37258 5.56283 0 12.0009 0C18.439 0 23.658 5.37258 23.658 12ZM11.4827 6.90101C11.4505 6.34683 11.9347 5.95008 12.4101 5.95008C12.8855 5.95008 13.3697 6.34683 13.3375 6.90101L13.106 13.1535C13.1031 13.3342 13.0302 13.5068 12.9022 13.6348C12.7717 13.7653 12.5947 13.8387 12.4101 13.8387C12.2255 13.8387 12.0485 13.7653 11.918 13.6348C11.79 13.5068 11.7171 13.3342 11.7142 13.1535L11.4827 6.90101ZM11.4813 15.9484C11.4813 15.436 11.8967 15.0204 12.4092 15.0204C12.9218 15.0204 13.3371 15.436 13.3371 15.9484C13.3371 16.4608 12.9218 16.8764 12.4092 16.8764C11.8967 16.8764 11.4813 16.4608 11.4813 15.9484Z"
      fill={props.fillColor || "#FF0000"}
    />
  </svg>
);
export default ExclamationWithFillColor;
